import React from "react";
import PropTypes from "prop-types";
import { completeOAuth } from "../../../utils/api/SyncApi";

export default class GoogleConfigurationLink extends React.Component {
  componentDidMount() {
    const self = this;
    const query = this.props.location.query;
    const done = () => self.context.router.push("/config/device/authentication/google");

    const storedState = localStorage.getItem("oauth_state_GOOGLE");
    localStorage.removeItem("oauth_state_GOOGLE");
    if (storedState && query.code && query.state && query.state === storedState) {
      completeOAuth(storedState, query.code).then(done, done);
      return;
    }
    done();
  }

  render() {
    return <div></div>;
  }
}

GoogleConfigurationLink.contextTypes = {
  router: PropTypes.object.isRequired,
};
